<template>
  <div
    class="header-bar-wrapper"
    :style="'padding-left:' + headerBarOffset + 'px;padding-right:' + headerBarOffset + 'px;'"
    v-if="!isModalImageActive"
  >
    <multibook-list @goTo="goTo" v-if="multibookListState && multiconfig" :multibooks-array="multibooksList">
    </multibook-list>
    <div
      class="multibook-list-active"
      v-if="multibookListState && multiconfig"
      @click="multibookListState = !multibookListState"
    ></div>
    <div class="title-wrapper">
      <dir
        class="home-icon-wrapper"
        :class="[{ 'hide-home-button': audioActive }]"
        @click="homeScreen()"
        title="Strona główna"
        v-if="isExternal"
      >
        <img :src="homeIcon" alt="Home" />
      </dir>
      <dir
        class="list-icon-wrapper"
        @click="multibookListState = !multibookListState"
        title="Menu wyboru"
        v-if="multibooksList.length > 1 && multibookListShow"
      >
        <img :src="listIcon" alt="Home" />
      </dir>
      <div
        class="header-title"
        :class="[{ headerElementHide: galleryActive }, { headerElementHide: isModalImageActive }]"
        v-if="multiconfig && multibookListShow"
      >
        <div id="multiBookTitle">
          <span class="multiBookTitleColor" :style="bookColorTheme">{{ multiconfigName }}</span>
          {{ multibookHeader.second }}
          <span v-if="devTool" class="multibook-header-version">
            <span class="multibook-header-version-text"> version </span>
            <span class="multibook-header-version-val"> {{ multibookHeader.version }} </span>
          </span>
          <div v-if="devTool" class="vimeo-state">
            <div class="actual-state">
              <span>vimeo status</span>
              <div class="actual-state-ball" :style="setVimeoStatusBcg(vimeoStatusCode)">
                {{ vimeoStatusCode ? vimeoStatusCode : '000' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="header-title"
        :class="[{ headerElementHide: galleryActive }, { headerElementHide: isModalImageActive }]"
        v-else
      >
        <div id="multiBookTitle">
          <span class="multiBookTitleColor" :style="bookColorTheme">{{ multibookHeader.main }}</span>
          {{ multibookHeader.second }}
          <span v-if="devTool" class="multibook-header-version">
            <span class="multibook-header-version-text"> version </span>
            <span class="multibook-header-version-val"> {{ multibookHeader.version }} </span>
          </span>
          <div v-if="devTool" class="vimeo-state">
            <div class="actual-state">
              <span>vimeo status</span>
              <div class="actual-state-ball" :style="setVimeoStatusBcg(vimeoStatusCode)">
                {{ vimeoStatusCode ? vimeoStatusCode : '000' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="multi-book-title-logo"
      :class="[{ headerElementHide: galleryActive }, { headerElementHide: isModalImageActive }]"
    >
      <div class="mac-logo" :title="getTooltips['macLogo']" @click="openUrl('www.mac.pl')"></div>
    </div>
  </div>
</template>
<script>
import MultibookList from './MultibookList/MultibookList';
import { LAUNCHER_URL } from '__mainSrcDir/config';
import _isUndefined from 'lodash/isUndefined';
import homePageConfig from '__mainSrcDir/config/homePage/homePage.js';

const packageJSON = require('__rootDir/package.json');

export default {
  name: 'header-bar',
  props: [
    // "defaultPage"
  ],
  components: { MultibookList },
  data: function () {
    return {
      multibookHeader: {
        main: packageJSON.multibookHeader.main,
        second: packageJSON.multibookHeader.second,
        version: packageJSON.version,
      },
      multibooksList: [],
      multibookListState: false,
    };
  },
  mounted() {
    if (homePageConfig && homePageConfig.multibooks) {
      this.multibooksList = homePageConfig.multibooks.filter((item) => {
        return _isUndefined(item.filePath);
      });
      if (this.multibooksList.length <= 1) {
        this.$store.commit('DISABLE_MULTIBOOK_LIST');
      }
    }
  },
  methods: {
    setVimeoStatusBcg(status) {
      let style = { background: '#34568B' };
      if (status == 200) {
        style.background = '#00A170';
      } else if (status == 401) {
        style.background = '#FA7A35';
      } else if (status == 404 || status == 503) {
        style.background = '#CD212A';
      }
      return style;
    },
    openUrl(link) {
      if (!this.$store.getters.isWeb) {
        this.$electron.shell.openExternal(link);
      } else {
        console.log('WEB openURL');
      }
    },
    homeScreen() {
      if (this.isWeb) {
        this.firstPage();
        window.location.replace(`/`);
      } else {
        this.redirectMain();
      }
    },
    firstPage() {
      this.$emit('firstPage');
    },
    redirectDev(type) {
      this.$router.push(`/${type}`);
    },
    redirectPage(id) {
      this.$router.push(`/page/${id}`);
    },
    redirectGame(type) {
      this.$router.push(`/game/${type}`);
    },
    redirectMain() {
      this.firstPage();
      setTimeout(() => {
        this.$router.push('/');
      }, 1200);
    },
    goTo(id) {
      this.multibookListState = false;
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', id);
      this.firstPage();
      this.$router.push({ name: `${id}-view` });
    },
  },
  computed: {
    vimeoStatusCode() {
      return this.$store.getters.stateVimeoStatusCode;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
    isModalImageActive() {
      return this.$store.getters.isModalImageActive;
    },
    galleryActive() {
      return this.$store.getters.galleryActive;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    headerBarOffset() {
      return this.$store.getters.headerBarOffset;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    isExternal() {
      return packageJSON.config.external;
    },
    multibookListShow() {
      return this.$store.getters.multibookListShow;
    },
    multibookListIndexShow() {
      return this.$store.getters.multibookListIndexShow;
    },
    multiconfigName() {
      return this.multibooksList.find((o) => o.name === this.$store.getters.multibookType)?.title;
    },
    audioActive() {
      return this.$store.getters.audioActive;
    },
    homeIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/home-48px.svg`);
      } catch {
        console.log(
          '%cHomeIcon HeaderBar- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    listIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/list.svg`);
      } catch {
        console.log(
          '%cListIcon HeaderBar- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    correctModuleName() {
      const name = `${this.$store.getters.multibookType
        .charAt(0)
        .toUpperCase()}${this.$store.getters.multibookType.slice(1)}`;
      return name;
    },
    bookColorTheme() {
      return { '--color': this.$store.getters[`${this.correctModuleName}/getBookColorTheme`] };
    },
    devTool() {
      return this.$store.getters.devTool;
    },
  },
};
</script>
<style lang="scss">
@import '~@/assets/sass/variable';
.header-bar-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  .multibook-list-active {
    position: fixed;
    top: 0;
    left: 0;
    width: 1920px;
    z-index: 99998;
    background: transparent;
    height: 1080px;
  }
  .home-icon-wrapper {
    display: flex;
    z-index: 1;
    justify-content: center;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    transition: all 0.4s ease;
    img:hover {
      cursor: pointer;
      background: url('~@/assets/icons/book/headerBar/home-on48px.svg');
    }
  }
  .hide-home-button {
    visibility: hidden;
    transition: visibility 0.1s ease;
  }
  .list-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    transition: all 0.4s ease;
  }
  .title-wrapper {
    display: flex;
    justify-content: center;
    align-self: center;
    .header-title {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 1rem;
    }
  }
  #multiBookTitle {
    font-size: larger;
    width: 60rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .multiBookTitleColor {
      padding-right: 0.6vh;
      color: var(--color, $multiBookTitleColor);
    }
    .multibook-header-version {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 1vw;
      .multibook-header-version-text {
        font-weight: bold;
        font-size: small;
        background-color: #5b5b5b;
        border-radius: 4px 0px 0px 4px;
        color: white;
        padding-left: 4px;
        padding-top: 1px;
        padding-bottom: 1px;
        padding-right: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .multibook-header-version-val {
        font-weight: bold;
        font-size: small;
        border-radius: 0px 4px 4px 0px;
        color: white;
        padding-left: 4px;
        padding-top: 1px;
        padding-bottom: 1px;
        padding-right: 5px;
        background-color: #0d7ebe;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
  .mac-logo {
    cursor: pointer;
    width: 45px;
    height: 39px;
    padding: 4px;
    background-image: url('~@/assets/icons/book/headerBar/mac_icon.png');
    background-size: contain;
    background-repeat: no-repeat;
    -webkit-font-smoothing: subpixel-antialiased;
  }
  .test-button {
    border: 1px solid $multiBookTitleColor;
    color: $multiBookTitleColor;
    transition: all 0.4s ease;
    padding: 3px;
  }
  .test-button:hover {
    border: 1px solid white;
    color: white;
    background-color: $multiBookTitleColor;
  }
}
.searchInputContainer {
  display: flex;
  width: 20vw;
  .searchButton {
    margin-left: 1vw;
  }
}
.headerElementHide {
  visibility: hidden !important;
}
.vimeo-state {
  font-weight: bold;
  margin-left: 1vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: larger;
  color: white;
  span {
    margin: 0px 5px;
  }
  .actual-state {
    height: 21px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: small;
    padding-left: 3px;
    // padding: 0px 10px;
    background: #5b5b5b;
    border-radius: 5px;
    .actual-state-ball {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 30px;
      height: 100%;
      border-radius: 0px 5px 5px 0px;
      background: gray;
    }
  }
}
</style>
